export const DEFAULT_ACCOUNT_IMAGE_PATH = '/tk-pictures/pouets_disparus_tykayn_mastodon.jpg';

export function isMissingAccountImage(url) {
  if (!url) {
    return true;
  }

  return url.endsWith('missing.png') || url.includes(DEFAULT_ACCOUNT_IMAGE_PATH);
}

export function resolveAccountImageUrl(url) {
  return isMissingAccountImage(url) ? DEFAULT_ACCOUNT_IMAGE_PATH : url;
}
